import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { useLastUsedProject } from './useLastUsedProject'

export const useLastUsedFolder = () => {
  const currentWorkspaceId = useCurrentWorkspaceId()
  const defaultProjectQuery = useLastUsedProject(currentWorkspaceId)

  return {
    lastUsedFolder: defaultProjectQuery?.data?.project,
    isLoading: defaultProjectQuery.isLoading,
  }
}
